module.exports = __webpack_public_path__ + "static/media/Logo.99f83415.svg";